export default __webpack_public_path__ + "static/media/loading-skull-mojo.bb82612d.gif";